import { createFileRoute } from "@tanstack/react-router";
import { CalendarCheck, NotebookPen, Video } from "lucide-react";
import { useOnceDataLayerEvent } from "@/lib/datalayer";
import { Layout } from "@/components/Layout";
import { Reveal } from "@/components/Reveal";
import { ProzessTimeline } from "@/components/buergermeisterwahl/ProzessTimeline";
import { CasesSection } from "@/components/cases/CasesSection";

export const Route = createFileRoute("/mentoring/danke")({
  head: () => ({
    meta: [
      { title: "Vielen Dank für Ihre Mentoring-Anfrage | creategy" },
      { name: "robots", content: "noindex, nofollow" },
      {
        name: "description",
        content:
          "Ihre Mentoring-Anfrage ist gebucht. Sie erhalten in wenigen Minuten eine Bestätigung mit Kalendereinladung per E-Mail.",
      },
      { property: "og:title", content: "Vielen Dank für Ihre Mentoring-Anfrage | creategy" },
      {
        property: "og:description",
        content:
          "Ihre Mentoring-Anfrage ist gebucht. Sie erhalten in wenigen Minuten eine Bestätigung mit Kalendereinladung per E-Mail.",
      },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://creategy.de/mentoring/danke" }],
  }),
  component: MentoringDankePage,
});

const STEPS = [
  { title: "Anfrage bestätigt", text: "Ihre Buchung ist bei uns eingegangen, die Kalendereinladung ist auf dem Weg zu Ihnen.", Icon: CalendarCheck },
  { title: "Kurze Vorbereitung", text: "Überlegen Sie vorab, welche Fragen Sie im Mentoring klären möchten. Unterlagen sind nicht nötig.", Icon: NotebookPen },
  { title: "Ihr Gespräch", text: "Wir besprechen Ihre Ausgangslage und stimmen gemeinsam ab, wie das Mentoring für Sie aussieht.", Icon: Video },
];

function MentoringDankePage() {
  useOnceDataLayerEvent({ event: "mentoring_anfrage" });
  return (
    <Layout>
      {/* Sektion 1: Hero */}
      <section>
        <div className="section-y mx-auto w-full max-w-[1400px] px-6 md:px-12">
          <h1 className="heading-h1 text-primary">
            Ihre Mentoring-Anfrage ist eingegangen.
          </h1>
          <p className="mt-8 max-w-2xl font-body text-base leading-relaxed text-foreground md:text-lg">
            Vielen Dank für Ihre Anfrage. Sie erhalten in wenigen Minuten eine Bestätigung mit Kalendereinladung per E-Mail. Falls Ihnen etwas dazwischenkommt, können Sie den Termin über den Link in dieser E-Mail jederzeit verschieben.
          </p>
        </div>
      </section>

      {/* Sektion 2: Prozess */}
      <section aria-labelledby="mentoring-danke-prozess">
        <div className="section-y mx-auto w-full max-w-[1400px] px-6 md:px-12">
          <Reveal>
            <h2 id="mentoring-danke-prozess" className="heading-h2 text-primary">
              So geht es weiter.
            </h2>
          </Reveal>
          <div className="mt-16 md:mt-20">
            <ProzessTimeline headingColor="text-primary" steps={STEPS} />
          </div>
        </div>
      </section>

      {/* Sektion 3: Cases */}
      <CasesSection
        includeTags={["buergermeisterwahl", "direktkandidaten"]}
        title={"Cases &\u00a0Referenzen"}
        description="Ein Auszug aus Projekten, die einem Erstgespräch wie Ihrem folgten."
        headingColor="text-primary"
      />
    </Layout>
  );
}
